import { Outlet, useLocation } from "react-router-dom"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { CountProvider } from "./components/CountProvider"
import { LogProvider } from "./components/LogProvider"
import { LocaleProvider } from "./components/LocaleProvider"
import { ToastContainer } from "./components/ui/toast"
import Header from "./components/Header"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false },
  },
})

function Layout() {
  const { pathname } = useLocation()
  return (
    <QueryClientProvider client={queryClient}>
      <CountProvider>
        <LogProvider>
          <LocaleProvider>
            <div className="min-h-screen bg-background">
              <Header />
              <main key={pathname}>
                <Outlet />
              </main>
            </div>
            <ToastContainer />
          </LocaleProvider>
        </LogProvider>
      </CountProvider>
    </QueryClientProvider>
  )
}

export default Layout
